__turbopack_context__.v({
  "counter": "Counter-module__PFBczG__counter",
  "counterDisabled": "Counter-module__PFBczG__counterDisabled",
  "counterDone": "Counter-module__PFBczG__counterDone",
  "counterZero": "Counter-module__PFBczG__counterZero",
});
